/**
 * 错误上报。页面里没被 catch 的异常和没被处理的 Promise 拒绝,各发一条到 /api/report。
 * 带上构建版本,不然收到一堆 index-xxxx.js:9:108556 也不知道该拿哪份 sourcemap 对。
 */
const VERSION = import.meta.env.VITE_VERSION as string;

function send(message: string, stack: string) {
  const body = JSON.stringify({ version: VERSION, url: location.href, message, stack });
  // keepalive:页面正在关闭也把这条发完
  fetch("/api/report", { method: "POST", headers: { "content-type": "application/json" }, body, keepalive: true }).catch(() => {});
}

addEventListener("error", (e) => send(e.message, e.error?.stack ?? `${e.filename}:${e.lineno}:${e.colno}`));
addEventListener("unhandledrejection", (e) => {
  const r = e.reason;
  send(r instanceof Error ? r.message : String(r), r instanceof Error ? (r.stack ?? "") : "");
});
